export default __webpack_public_path__ + "static/media/md.96e49231.svg";